import { render, staticRenderFns } from "./pathReview.vue?vue&type=template&id=590ad7fc&"
import script from "./pathReview.vue?vue&type=script&lang=js&"
export * from "./pathReview.vue?vue&type=script&lang=js&"
import style0 from "./pathReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports